

export const BootstrapStyle = {
    button: 'btn mt-3 p-3 w-100 d-flex justify-content-center align-items-center',
    input: 'form-control shadow-none border-0',
    floatingLabel: 'form-floating d-flex align-items-center mb-1',
    formGroup: 'form-group mb-3',
    passwordButton: 'btn shadow-none border-0'
}